export default "<div class=\"my-login-page\">\n  \n</div>";